import { styled } from "@mui/material";

export const DisabledTooltipAnchor = styled("span")({
  height: "fit-content",
});
